import { useState, useEffect } from 'react';
import storageService from '../../services/storage-service';
import Dialog from '../../toolkit/dialog';
import confirm from '../../utils/confirm';
import { FormGroup, Row, Select } from '../widgets';
import ExportFilterList, { ExportFilterListProps } from './ExportFilterList';
import ExportStatusDialog from './ExportStatusDialog';
import * as internal from './internal';

const { Option } = Select;

const ExportTab: React.FC = () => {

  const [db, setDb] = useState(null);
  const [pretty, setPretty] = useState(null);
  const [collections, setCollections] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function getData() {
      const response = await storageService.fetchConfigs();
      setData(response);
      setDb(response[0]['db']);
      setCollections(internal.normalizeCollections(response[0]['collections']));
    }
    getData();
  }, []);

  const handlePrettyChange = (value: any) => setPretty(value);

  const handleDbChange = (value: string) => {
    const found = data.find(x => x.db === value);
    setDb(found ? found.db : null);
    setCollections(found ? (found.collections ?? []) : []);
  }

  const handleEnabledChange = (name: string) => {
    setCollections(collections.map(item => {
      if (item.name === name)
        item.enabled = !item.enabled;
      return item;
    }));
  }

  const handleFilterChange = (name: string, filter: string, value: any) => {
    const updated = internal.modifyCollectionFilter(collections, name, filter, value);
    setCollections(updated);
  }

  const handleExportClicked = async () => {
    const body = {
      pretty: pretty === 'pretty',
      db,
      collections: internal.prepareCollections(collections)
    }
    if (Object.keys(body.collections).length === 0) {
      return confirm({
        title: 'برای پشتیبان گیری باید حداقل یک مورد را انتخاب کنید.',
        type: 'alert',
        cancelText: 'باشه',
        primaryClass: 'd-none',
        onSubmit: undefined
      }).show();
    }
    const result = await storageService.requestForExport(body);
    const dialog = new Dialog({
      rtl: true,
      title: 'در حال پشتیبان گیری اطلاعات',
      size: 'small',
      message: ExportStatusDialog
    });
    dialog.show({ _id: result._id });
  }

  return (
    <Row>
      <div className="col-xxl-3">
        <FormGroup>
          <label htmlFor="select-db">دیتابیس</label>
          <Select id="select-db" value={db} onChange={handleDbChange}>
            {data.map(x => <Option key={x.db} value={x.db}>{x.db}</Option>)}
          </Select>
        </FormGroup>
        <FormGroup>
          <label htmlFor="select-db">فشرده</label>
          <Select id="select-db" value={pretty} onChange={handlePrettyChange}>
            <Option value={null}>{'فعال'}</Option>
            <Option value={'pretty'}>{'غیرفعال'}</Option>
          </Select>
        </FormGroup>
      </div>
      <div className="col-xxl-12">
        {collections.map((item: ExportFilterListProps, i) => (
          <ExportFilterList
            key={i}
            enabled={item.enabled}
            onEnabledChange={handleEnabledChange}
            onFilterChange={handleFilterChange}
            {...item}
          />
        ))}
      </div>
      <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mx-auto">
        <button
          onClick={handleExportClicked}
          className="ant-btn ant-btn-primary ant-btn-lg btn-block">پشتیبان گیری</button>
      </div>
    </Row>
  );
}

export default ExportTab;
